import { useState, useMemo, useCallback } from "react";
import ReactSelect from "react-select";
import Icon from "./icon";
import classNames from "classnames";
import { sortFunction, sortOptionToQuery } from "../utils/sorting";
import Pagination from "./pagination";
import RequestItem from "./request-item";

const PAGE_SIZE = 12;

const Requests = ({
  currentRequests,
  setCurrentRequest,
  labels,
  sortingOptions,
  columnItemTitle,
  clickableCondition = [],
  hideSendCondition,
  defaultSorting = { sortingDesc: true, sorting: "DATE" },
  deleteObj,
  submitObj,
  editRequest,
  cancelRequest,
  type,
  showChevron = () => false,
}) => {
  const [orderBy, setOrderBy] = useState(defaultSorting);
  const [page, setPage] = useState(1);

  const requests = useMemo(
    () =>
      currentRequests
        ?.sort((a, b) => sortFunction(a, b, orderBy, labels))
        ?.slice(0, PAGE_SIZE * page),
    [page, orderBy, currentRequests, labels]
  );

  const sortingCondition = useCallback(
    (name, above = false) =>
      (orderBy?.sorting === name ? (above ? orderBy?.sortingDesc : !orderBy?.sortingDesc) : true)
        ? "sort-light"
        : "sort-solid",
    [orderBy]
  );

  const onChange = useCallback((selectedOption) => {
    const querySortOptions = sortOptionToQuery(selectedOption.value);
    setOrderBy({
      ...querySortOptions,
    });
  }, []);

  const toggleSort = (e) => {
    const selectedSorting = e.currentTarget?.name;
    setOrderBy((current) => ({
      sortingDesc: current.sorting === selectedSorting ? !current.sortingDesc : true,
      sorting: selectedSorting,
    }));
  };

  const selectedOption = sortingOptions?.find(
    (option) =>
      option.value.split("_")?.[0] === orderBy.sorting && option.desc === orderBy.sortingDesc
  );

  return (
    <>
      <ul className="table">
        <li className="table__header">
          {columnItemTitle?.map((option, i) => (
            <button
              className={classNames(
                "table__box table__box--title",
                option?.className,
                option.name === "STATUS" && "table__box--fixed"
              )}
              name={option.name}
              onClick={toggleSort}
              key={option.name || i}
              disabled={!option.name}
            >
              {option.label}
              {option.name && (
                <div className="table__sort">
                  <Icon name={sortingCondition(option.name, true)} />
                  <Icon name={sortingCondition(option.name)} />
                </div>
              )}
            </button>
          ))}
          <div className="action"></div>
        </li>
        <div className="table__select">
          <span> {labels?.ORDER_BY}:</span>
          <ReactSelect
            options={sortingOptions}
            className="borse__select"
            classNamePrefix="app-select"
            aria-label="OrderBy select"
            value={selectedOption}
            onChange={onChange}
            isSearchable={false}
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator: () => (
                <>
                  <Icon name="sort-light" />
                  <Icon name="sort-light" />
                </>
              ),
            }}
          />
        </div>
        {requests?.map((request) => (
          <RequestItem
            request={request}
            key={request?.id}
            labels={labels}
            setCurrentRequest={setCurrentRequest}
            columnItemTitle={columnItemTitle}
            clickableCondition={clickableCondition}
            hideSendCondition={hideSendCondition(request)}
            deleteObj={deleteObj}
            submitObj={submitObj}
            editRequest={editRequest}
            cancelRequest={cancelRequest}
            type={type}
            showChevron={showChevron}
          />
        ))}
      </ul>
      {currentRequests?.length > PAGE_SIZE && (
        <Pagination
          currentItemCount={requests?.length}
          pagination={{
            resultsAvailableCount: currentRequests?.length,
          }}
          loadMore={() => setPage((current) => current + 1)}
          labels={labels}
        />
      )}
    </>
  );
};

export default Requests;
